import React, { useState, useEffect } from 'react';
import './Footer.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { TbReportAnalytics } from "react-icons/tb";
import { LuLayoutPanelLeft } from "react-icons/lu";
import { HiHome } from "react-icons/hi2";
import { useAuthPrompt } from '../../hooks/auth/useAuthPrompt';

function Footer({ onOpenRegister }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;

  // فراخوانی هوک بررسی احراز هویت و تکمیل پروفایل
  const { checkAuthAndRun } = useAuthPrompt(onOpenRegister);

  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    const handleFocusIn = (e) => {
      const tag = e.target.tagName.toLowerCase();
      if (tag === 'input' || tag === 'textarea') {
        setIsKeyboardOpen(true);
      }
    };

    const handleFocusOut = () => {
      setIsKeyboardOpen(false);
    };

    window.addEventListener('focusin', handleFocusIn);
    window.addEventListener('focusout', handleFocusOut);

    return () => {
      window.removeEventListener('focusin', handleFocusIn);
      window.removeEventListener('focusout', handleFocusOut);
    };
  }, []);

  const getActiveItem = () => {
    if (pathname === '/StorePanelStation') return 1;
    if (pathname === '/Report') return 3;
    return 2;
  };

  const active = getActiveItem();

  const handleHomeClick = (e) => {
    e.preventDefault();
    sessionStorage.removeItem("store");
    navigate("/", { replace: true });
  };

  // بررسی وضعیت احراز و هدایت به پنل سبد / سفارشات
  const handlePanelClick = (e) => {
    e.preventDefault();
    checkAuthAndRun(() => navigate('/StorePanelStation'));
  };

  // بررسی وضعیت احراز و هدایت به گزارشات
  const handleReportClick = (e) => {
    e.preventDefault();
    checkAuthAndRun(() => navigate('/Report'));
  };

  if (isKeyboardOpen) {
    return null;
  }

  return (
    <>
      <div className="bottom-fade"></div>

      <div className='footer-navbar'>
        <div className="navbar-panel">
          <div
            className={`navbar-item ${active === 1 ? "active" : ""}`}
            onClick={handlePanelClick}
            style={{ cursor: 'pointer' }}
          >
            <div>
              <div><LuLayoutPanelLeft size={"25px"} /></div>
              <div>سبد من</div>
            </div>
          </div>
        </div>

        <div className="navbar-home">
          <Link
            className={`navbar-item ${active === 2 ? "active" : ""}`}
            to="/"
            onClick={handleHomeClick}
          >
            <div>
              <div><HiHome size={"25px"} /></div>
              <div>خانه</div>
            </div>
          </Link>
        </div>

        <div className="navbar-report">
          <div
            className={`navbar-item ${active === 3 ? "active" : ""}`}
            onClick={handleReportClick}
            style={{ cursor: 'pointer' }}
          >
            <div>
              <div><TbReportAnalytics size={"25px"} /></div>
              <div>گزارشات</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
